define.alias("shared/utils/object-methods/object-camel-to-snake", "calendar/utils/object-methods/object-camel-to-snake");